/** Carriers sahifalari lug'ati (ru). */
export default {
  title: "Перевозчики",
  subtitle_one: "{{count}} перевозчик · статистика: {{scope}}",
  subtitle_few: "{{count}} перевозчика · статистика: {{scope}}",
  subtitle_many: "{{count}} перевозчиков · статистика: {{scope}}",
  subtitle_other: "{{count}} перевозчиков · статистика: {{scope}}",
  newCarrier: "+ Новый перевозчик",
  filters: {
    status: "Статус",
    statusAll: "Статус: все",
    hiringState: "Штат найма",
    hiringAny: "Штат найма: любой",
    trucks: "Траки",
    trucksAll: "Любые траки",
    trucksAvailable: "Есть свободные траки",
    trucksExpiring: "Сроки документов траков",
    trucksAny: "Есть траки",
    openOnly: "Только с открытыми вакансиями",
    searchPlaceholder: "Поиск по названию, MC, контакту",
    searchAria: "Поиск перевозчиков",
  },
  empty: {
    filtered: "Нет перевозчиков по этим фильтрам",
    none: "Перевозчиков пока нет",
    manager: "Добавьте транспортные компании, куда вы устраиваете водителей.",
    viewer: "Перевозчиков добавляет ваш менеджер.",
  },
  columns: {
    name: "Название",
    mcDot: "MC / DOT",
    status: "Статус",
    mainContact: "Основной контакт",
    hiringStates: "Штаты найма",
    openJobs: "Открытые вакансии",
    freeTrucks: "Свободные траки",
    submitted: "Отправлено",
    hired: "Нанято",
    rejection: "Отказы",
    driver: "Водитель",
    recruiter: "Рекрутер",
    job: "Вакансия",
    date: "Дата",
    states: "Штаты",
    experience: "Опыт",
    pay: "Оплата",
    homeTime: "Время дома",
    equipment: "Техника",
    candidates: "Кандидаты",
    carrierReply: "Ответ перевозчика",
    decided: "Решение",
  },
  pagination: { carriers: "перевозчиков", candidates: "кандидатов" },
  scope: { allBranches: "все филиалы", yourBranch: "ваш филиал", myDrivers: "мои водители" },
  states48: "48 штатов",
  withdrawn: "Отозван",
  rejectedWith: "Отказ · {{reason}}",
  reply: {
    noReply_one: "нет ответа · {{count}} день",
    noReply_few: "нет ответа · {{count}} дня",
    noReply_many: "нет ответа · {{count}} дней",
    noReply_other: "нет ответа · {{count}} дней",
    waiting_one: "ожидание · {{count}} день",
    waiting_few: "ожидание · {{count}} дня",
    waiting_many: "ожидание · {{count}} дней",
    waiting_other: "ожидание · {{count}} дней",
    started: "вышел {{date}}",
  },
  profile: {
    notFound: "Перевозчик не найден.",
    statusToast: { active: "Перевозчик возобновлён", paused: "Перевозчик приостановлен", stopped: "Перевозчик остановлен" },
    updateFailed: "Не удалось обновить перевозчика",
    hiringIn: "Нанимает в: {{states}}",
    mainContact: "Основной контакт:",
    pause: "Приостановить",
    resume: "Возобновить",
    newJob: "+ Новая вакансия",
    resumeFirst: "Сначала возобновите перевозчика",
    tabs: { overview: "Обзор", jobs: "Вакансии ({{count}})", candidates: "Кандидаты ({{count}})", trucks: "Траки ({{count}})", trucksFree: "Траки ({{count}} · {{free}} свободно)", notes: "Заметки" },
    kpi: {
      submitted: "Отправлено",
      hired: "Нанято",
      rejectionRate: "Доля отказов",
      openJobs: "Открытые вакансии",
      allTime: "за всё время · {{scope}}",
      ofSubmitted: "{{pct}}% от отправленных",
      noSubmissions: "отправок пока нет",
      rejectedOf: "{{rejected}} из {{submitted}} отправленных",
      carrierStatus: "перевозчик {{status}}",
      jobsTotal_one: "всего {{count}} вакансия",
      jobsTotal_few: "всего {{count}} вакансии",
      jobsTotal_many: "всего {{count}} вакансий",
      jobsTotal_other: "всего {{count}} вакансий",
    },
    openJobs: "Открытые вакансии ({{count}})",
    allJobs: "Все вакансии →",
    noOpenJobs: "Открытых вакансий нет.",
    topReasons: "Основные причины отказов",
    inScope: "охват: {{scope}}",
    noRejections: "Отказов пока нет.",
    recentCandidates: "Последние кандидаты",
    allCandidates: "Все кандидаты →",
    noCandidatesForCarrier: "Этому перевозчику ещё не отправляли кандидатов.",
    noJobs: "У этого перевозчика нет вакансий",
    candidatesCount_one: "{{count}} кандидат",
    candidatesCount_few: "{{count}} кандидата",
    candidatesCount_many: "{{count}} кандидатов",
    candidatesCount_other: "{{count}} кандидатов",
    hiredOf: "нанято {{hired}} из {{openings}}",
    noCandidatesYet: "Кандидатов пока нет",
    noCandidatesHint: "Здесь появятся водители, отправленные на вакансии этого перевозчика.",
    notesTitle: "Заметки и отправка",
    submissionMethod: "Способ отправки",
    replyTime: "Срок ответа",
    hiringStates: "Штаты найма",
    added: "Добавлен",
    notes: "Заметки",
    noNotes: "Заметок нет. Менеджеры могут указать, как этот перевозчик предпочитает получать водителей.",
    resumeQ: "Возобновить {{name}}?",
    pauseQ: "Приостановить {{name}}?",
    resumeDesc: "Водителей снова можно будет отправлять этому перевозчику. Закрытые вакансии останутся закрытыми, пока вы их не откроете.",
    pauseDesc: "Открытые вакансии будут закрыты, отправка водителей станет невозможна. На кандидатов в процессе это не влияет.",
    pauseCarrier: "Приостановить перевозчика",
    openJobsNow_one: "Сейчас {{count}} открытая вакансия.",
    openJobsNow_few: "Сейчас {{count}} открытые вакансии.",
    openJobsNow_many: "Сейчас {{count}} открытых вакансий.",
    openJobsNow_other: "Сейчас {{count}} открытых вакансий.",
  },
  form: {
    nameRequired: "Укажите название перевозчика.",
    placementFee: "Оплата за нанятого водителя ($)",
    placementFeeHint: "По умолчанию для каждого нового найма",
    mcRequired: "Укажите номер MC.",
    saved: "Перевозчик сохранён",
    created: "Перевозчик создан",
    saveFailed: "Не удалось сохранить перевозчика.",
    editTitle: "Редактировать перевозчика",
    newTitle: "Новый перевозчик",
    name: "Название перевозчика",
    mc: "MC №",
    dot: "DOT №",
    status: "Статус",
    mainContact: "Основной контакт",
    phone: "Телефон",
    email: "Email",
    city: "Город",
    state: "Штат",
    replyTime: "Срок ответа",
    replyPlaceholder: "обычно 3 рабочих дня",
    hiringStates: "Штаты найма",
    all48: "Все 48 штатов",
    pickStates: "Выберите штаты, где нанимает этот перевозчик",
    submissionMethod: "Способ отправки",
    submissionHint: "Как отправляются водители: email-пакет, Tenstreet, портал перевозчика...",
    submissionPlaceholder: "email-пакет",
    notes: "Заметки",
    notesPlaceholder: "Предпочитает водителей в радиусе 150 миль от Далласа",
  },
  trucks: {
    add: "Добавить трак",
    newTitle: "Новый трак",
    editTitle: "Трак {{unit}}",
    created: "Трак добавлен",
    saved: "Трак сохранён",
    saveFailed: "Не удалось сохранить трак",
    statusSet: "Статус: {{status}}",
    archiveTitle: "Архивировать трак {{unit}}?",
    archiveDesc: "Он уйдёт из списка и подсчётов. История сохранится, можно восстановить.",
    archived: "Трак в архиве",
    expired: "истёк",
    noDriver: "Нет водителя",
    freeCount_one: "{{count}} свободный трак",
    freeCount_few: "{{count}} свободных трака",
    freeCount_many: "{{count}} свободных траков",
    freeCount_other: "{{count}} свободных трака",
    expiringCount_one: "{{count}} трак: сроки документов",
    expiringCount_few: "{{count}} трака: сроки документов",
    expiringCount_many: "{{count}} траков: сроки документов",
    expiringCount_other: "{{count}} трака: сроки документов",
    empty: "Траков пока нет",
    emptyFiltered: "Нет траков с таким статусом",
    emptyManager: "Добавьте траки перевозчика: свободный трак — перевозчику нужен водитель.",
    emptyViewer: "Траки добавляет менеджер или владелец.",
    chips: { all: "Все" },
    cols: { truck: "Трак", trailer: "Трейлер", status: "Статус", driver: "Водитель", location: "Где", plate: "Номер · VIN", insurance: "Страховка", inspection: "Инспекция" },
    sections: { basic: "Трак", trailer: "Трейлер", registration: "Регистрация и сроки", location: "Местоположение и водитель" },
    f: {
      unit: "Unit #", status: "Статус", statusHint: "С водителем трак — Занят", year: "Год", make: "Марка", model: "Модель", cab: "Кабина", transmission: "Коробка",
      trailerType: "Тип трейлера", trailerLength: "Длина (фут)", plate: "Госномер", plateState: "Штат номера", insurance: "Страховка до",
      inspection: "Годовая инспекция до", inspectionHint: "Ежегодная инспекция DOT", city: "Город", state: "Штат", crew: "Соло / команда",
      driver: "Водитель", coDriver: "Второй водитель (команда)", noDriver: "Без водителя", noHired: "К этому перевозчику ещё никого не наняли", notes: "Заметки",
    },
    cab: { sleeper: "Со спальником", day_cab: "Day cab" },
    transmission: { automatic: "Автомат", manual: "Механика" },
    crew: { solo: "Соло", team: "Команда" },
    trailer: { dry_van: "Dry van", reefer: "Рефрижератор", flatbed: "Flatbed", step_deck: "Step deck", conestoga: "Conestoga", tanker: "Цистерна", power_only: "Power only", box_truck: "Box truck", car_hauler: "Автовоз", other: "Другое" },
  },
};
